import { t } from 'src/i18n';

/**
 * Validates tutorial registration request according to guide vs course rules.
 *
 * Guide rules:
 * - Exactly 1 participant
 * - No employeeUuid
 * - No dueDate
 *
 * Course rules:
 * - 1+ participants
 * - All participants must have employeeUuid
 * - Must have dueDate
 */
export function validateTutorialRegistration(params: {
  isGuide: boolean;
  participants: Array<{ id: string; employeeUuid: string | null }>;
  dueDate: string | null;
}): { valid: boolean; error?: string } {
  const { isGuide, participants, dueDate } = params;

  if (isGuide) {
    // Guide validation
    if (participants.length !== 1) {
      return {
        valid: false,
        error: t('validation.guideExactlyOneParticipant', { count: participants.length }),
      };
    }

    if (participants.some((p) => p.employeeUuid)) {
      return {
        valid: false,
        error: t('validation.guideNoEmployeeUuid'),
      };
    }

    if (dueDate) {
      return {
        valid: false,
        error: t('validation.guideNoDueDate'),
      };
    }
  } else {
    // Course validation
    if (participants.length === 0) {
      return {
        valid: false,
        error: t('validation.courseAtLeastOneParticipant'),
      };
    }

    if (!participants.every((p) => p.employeeUuid)) {
      return {
        valid: false,
        error: t('validation.courseAllParticipantsEmployeeUuid'),
      };
    }

    if (!dueDate) {
      return {
        valid: false,
        error: t('validation.courseDueDate'),
      };
    }
  }

  return { valid: true };
}
